// Catch likely typos in an email before a bill is sent to it: a misspelt common domain
// (gmial.com, gmail.co) or a name in the address that is one letter off the member's own name
// (adhirajarona@ for Adhiraj Arora). Returns {message, suggestion} or null.

const DOMAINS = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "icloud.com", "yahoo.co.in", "rediffmail.com", "live.com", "ymail.com", "yahoo.in", "hotmail.co.uk", "googlemail.com"];

function distance(a, b) {
  const dp = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) dp[i][j] = Math.min(dp[i][j], dp[i - 2][j - 2] + 1);
    }
  }
  return dp[a.length][b.length];
}

export function emailWarning(email, name = "") {
  const e = (email || "").trim().toLowerCase();
  const at = e.lastIndexOf("@");
  if (at < 1) return null;
  const local = e.slice(0, at);
  const domain = e.slice(at + 1);
  if (!DOMAINS.includes(domain)) {
    const near = DOMAINS.find((d) => distance(domain, d) <= 2 && Math.abs(d.length - domain.length) <= 2);
    if (near) return { message: `"${domain}" looks like a typo for ${near}.`, suggestion: `${local}@${near}` };
  }
  // A part of their name that's in the address with one letter wrong
  const letters = local.replace(/[^a-z]/g, "");
  for (const part of (name || "").toLowerCase().split(/[^a-z]+/).filter((p) => p.length >= 5)) {
    if (letters.includes(part)) continue;
    for (let i = 0; i + part.length <= letters.length; i++) {
      const piece = letters.slice(i, i + part.length);
      if (distance(piece, part) === 1) {
        const fixed = local.includes(piece) ? `${local.replace(piece, part)}@${domain}` : null;
        return { message: `The email has "${piece}" but the name is "${part}". Is the email spelt right?`, suggestion: fixed };
      }
    }
  }
  return null;
}
